<template>
  <div class="livechat" dir="ltr">
    <div
      class="flex relative bg-white m-auto overflow-hidden shadow-lg rounded-lg border-2 border-solid border-white"
      style="height: calc(100vh - 8.1em)"
    >
      <div
        class="w-full inset-0 absolute md:relative z-10 bg-white md:w-1/3 flex-col"
        :class="showUsers ? 'flex' : 'hidden'"
      >
        <div>
          <!-- Search form -->
          <div class="flex w-full p-2">
            <button
              type="button"
              @click="showUsers = !showUsers"
              class="flex items-center justify-center bg-blue-500 bg-grey bg-opacity-25 rounded-full border-0 cursor-pointer text-black h-12 w-12 inline-block md:hidden"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18 18 6M6 6l12 12"
                />
              </svg>
            </button>
            <div class="flex-1 w-full relative">
              <input
                type="text"
                v-model="query"
                class="w-full border-0 px-4 py-2 h-full border border-grey border-solid rounded-full"
                placeholder="Email, Name..."
              />
              <div class="flex absolute top-0 bottom-0 right-0">
              <!-- close button -->
              <button
                v-if="query.length > 0"
                @click="clear();"
                class="flex items-center justify-center border-0 cursor-pointer h-full w-10"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-4 h-4"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6 18 18 6M6 6l12 12"
                  />
                </svg>
              </button>
              <button
                @click="getUsers()"
                class="flex items-center justify-center bg-green-600 text-white rounded-full border-0 cursor-pointer bg-dark-grey h-full w-10"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                  />
                </svg>
              </button>
            </div>
            </div>
         
          </div>
        </div>
        <!-- Users -->
        <div class="w-full h-full flex-1 overflow-auto">
          <div
            v-if="users.length  == 0"
            :key="-1"
            class="p-2 flex border-0 bg-white w-full shadow rounded-lg cursor-pointer hover:bg-light my-2"
          >
            <div class="flex w-full">
              <b
                class="flex items-center justify-center w-12 h-12 rounded-full bg-dark-grey text-white"
                >L</b
              >
              <span
                style="width: calc(100% - 3rem)"
                class="flex flex-1 flex-col items-start px-2 box-border"
              >
                <span class="flex justify-between w-full">
                  <h4 class="text-lg font-bold">Search to Start connecting with the people</h4>
                </span>
                <span class="text-ellipsis truncate w-full">
                </span>
              </span>
            </div>
          </div>
          <div v-for="u in users" :key="u._id" @click="openConversation(u._id,u)" class="p-2 flex w-full">
            <div v-if='u.fullName'
              class="flex w-full rounded-md px-2 py-4 cursor-pointer hover:bg-gray-200"
              :class="`${(user && u._id == user.key) ? 'bg-green-600' : 'bg-white'}`"
            >
              <div
                class="flex items-center justify-center w-12 h-12 rounded-full bg-gray-500 relative"
              >
                <!-- <img v-if="u.country" class="w-8 h-8 rounded-full object-cover" :src="`data:image/png;base64,${$getFlug(u.country)}`"> -->
                <b
                  class="flex items-center justify-center w-8 h-8 rounded-full bg-dark-grey text-lg uppercase text-white"
                  >{{u.fullName && u.fullName.substring(0,1)}}</b>
              </div>
              <span
                style="width: calc(100% - 3rem)"
                class="flex flex-1 flex-col items-start px-2 box-border"
              >
                <span class="flex justify-between w-full">
                  <h4 class="text-lg text-left font-bold capitalize" :class="`${(user && u._id == user.key) ? 'text-white' : ''}`">
                    {{u.fullName}}
                  </h4>
                  <span class="text-xs" :class="`${(user && u._id == user.key) ? 'text-white' : 'text-gray-500'}`">{{
                    $moment(u.lastActivity).format("D MMM  hh:mm A")
                  }}</span>
                </span>
                <span class="text-ellipsis truncate w-full text-left">
                  <!-- Single line wrap -->
                  <span v-if="u.unread && u.lastFrom=='user'" class="px-1 py-0 text-sm uppercase text-white rounded-md inline-block bg-red-500">{{ u.unread }}</span>
                  <span v-if="u.unread && u.lastFrom=='user'" class="mx-1"></span>
                  <span v-if="u.lastMessage" class="text-sm w-full text-secondary" :class="`${(user && u._id == user.key) ? 'text-gray-200' : ''}`">{{ u.lastMessage }}</span>
                </span>
              </span>
            </div>
          </div>
          <button
            class="p-2 flex border-0 bg-primary text-white w-full shadow rounded-lg cursor-pointer my-2"
            v-if="users.length >= limit"
            key="99999"
            @click="getUsers(true)"
          >
            Load more
          </button>
        </div>
      </div>
      <!-- Chat -->
      <div
        class="w-full md:w-2/3 flex flex-col relative"
        style="
          background-color: #dddddd;
          background-image: url('https://storeno.b-cdn.net/managers/5-2022/1653126948822.png');
          background-size: contain;
          background-repeat: repeat;
        "
      >
          <div  v-if="!user" class="flex flex-col h-full justify-center items-center bg-white bg-opacity-50">
          <div
            class="flex items-center justify-center rounded-full w-32 h-32 bg-green-200"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-20 h-20 text-green-600"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
              />
            </svg>
          </div>

          <p
            class="text-center text-disabled text-gray-500 mt-4"
            style="max-inline-size: 40ch; text-wrap: balance"
          >
            Start connecting with the people by selecting one of the contact on
            left
          </p>
        </div>
        <div v-else class="flex flex-col h-full">
          <div class="flex w-full p-2 bg-white text-black">
            <button
              type="button"
              @click="showUsers = !showUsers"
              class="flex items-center justify-center bg-blue-500 bg-grey bg-opacity-25 rounded-full border-0 cursor-pointer text-black h-12 w-12 inline-block md:hidden"
            >
              <!-- list icon -->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
                />
              </svg>
            </button>
            <b
              class="flex items-center justify-center w-12 h-12 rounded-full bg-gray-400 text-white uppercase"
              >{{user.fullName && user.fullName.substring(0,1)}}</b>
            <span
              style="width: calc(100% - 6rem)"
              class="flex flex-1 flex-col items-start px-2 box-border"
            >
              <span class="flex justify-between w-full">
                <h3 class="text-xl font-bold text-black capitalize">
                  {{user.fullName}}
                </h3>
              </span>
              <span class="text-ellipsis truncate w-full">
                <!-- Single line wrap -->
                <span class="text-xs w-full text-secondary">{{
                  $moment(Number(user.lastActivity)).format("D MMM YYYY hh:mm A")
                }}</span>
              </span>
            </span>
            <!-- <button v-if="user.stores" type="button" @click="showDetails = !showDetails" class="flex items-center justify-center bg-blue-500 bg-grey bg-opacity-25 rounded-full border-0 cursor-pointer text-black h-12 w-12">
                            e
                        </button> -->
            <!-- else -->
            <span>•••</span>
            <!-- <div class="absolute inset-0 bg-black bg-opacity-50 z-10" v-if="showDetails">
                            <button class="border-0 bg-transparent absolute inset-0" @click="showDetails=false"></button>
                            <div class="bg-light absolute p-2 rounded-lg shadow-xl" style="top:2.5em;right:0; max-width: 90%; min-width:320px">
                                <div class="flex bg-black rounded-lg w-full justify-between items-center p-2">
                                    <b class="uppercase text-white">{{ "stores" }}</b>
                                    <button @click="showDetails=false" class="flex items-center justify-center bg-blue-500 bg-grey bg-opacity-25 rounded-full border-0 cursor-pointer text-white h-10 w-10">
                                        <feather-icon icon="XIcon" class="w-6 h-6" />
                                    </button>
                                </div>
                                <div v-for="store in user.stores" :key="store._id" class=" bg-white my-1 rounded-lg shadow-lg flex flex-col">
                                    <div class="p-2 flex flex-col" style="border-bottom:1px solid #dddddd">
                                        <small class=" text-secondary">{{ store.name }}</small>
                                        <a class="uppercase text-lg text-primary" :href="`//${store.subdomain}`" target="_blank">{{ store.subdomain }}</a>
                                        <a v-if="store.domain" class="uppercase text-xl text-success" :href="`//${store.domain.name}`" target="_blank">{{ store.domain.name }}</a>
                                        <small class=" text-secondary">{{ store.owner.email }}</small>
                                        <small class=" text-secondary">{{ store.owner.phone }}</small>
                                    </div>
                                    <div class="flex justify-between items-center p-2">
                                        <span class="p-1 rounded-lg text-xs bg-black text-white">{{ store.status }}</span>
                                        <span class="p-1 rounded-lg text-xs bg-dark-grey text-white">{{ store.pack.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    </div>
                    <!-- messages list -->
                    <div class="w-full h-full flex-1 overflow-auto px-1" id="scroll-box">
                        <div class="flex flex-col w-full" v-for="(message,i) in messages" :key="message.key">
                            <!-- Show day if different -->
                            <div v-if="i == 0 || $moment(Number(message.key)).format('D MMM') != $moment(Number(messages[i-1].key)).format('D MMM')" class="flex justify-between items-center w-full my-2">
                                <span style="border-bottom:2px solid #ffffff" class="flex-grow shadow"></span>
                                <span class="text-secondary bg-white p-2 rounded-lg shadow-lg">{{ $moment(Number(message.key)).format('D MMM YYYY') }}</span>
                                <span style="border-bottom:2px solid #ffffff" class="flex-grow shadow"></span>
                            </div>
                            <div class="flex relative" :class="` message-from-${message.from}`">
                                <div :style="`max-width:90%;${message.content.indexOf('iframe') != -1 ? 'width:100%':'' }`" v-if="message.type == 'text'" class="flex flex-col overflow-hidden relative rounded-lg my-2 message-text">
                                    <div class="flex px-2 flex-col">
                                        <div class="flex gap-2">
                                            <b
                                            :class=" message.from == 'admin' ? 'order-2': 'order-1'"
                                             class="flex items-center justify-center w-8 h-8 rounded-full bg-gray-500 text-lg uppercase text-white"
                                             >{{ message.from == 'admin' ? message.admin.substring(0,1) || 'Storeino Support'.substring(0,1) : user && user.name.substring(0,1) }}</b>
                                            <div dir="auto" 
                                            :class=" message.from == 'admin' ? 'order-1 text-white bg-green-600': 'order-2 bg-white'"
                                            class="p-2 pr-5 rounded-md" v-html="message.content"></div>
                                        </div>
                                        <span class="flex gap-2 items-center" :class=" message.from == 'admin' ? 'px-2': 'px-8'">
                                            <span v-if="message.seen && message.from == 'admin'" class="w-4 h-4">
                                                <svg class="w-4 h-4" :class="message.from == 'admin'?' text-green-500':' text-green-500'"  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                              <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                            </svg> </span>
                                                <span class="text-xs">{{ $moment(Number(message.key)).format('hh:mm A') }}</span>
                                                <button class="flex justify-center items-center cursor-pointer rounded-lg p-1 border-0 bg-transparent text-opacity-50 hover:text-danger hover:text-opacity-100" @click="deleteMessage(message)">
                                                    x
                                                </button>
                                            </span>
                                    </div>
                                </div>
                                <div style="max-width:90% !important" v-else-if="message.type == 'image'" class="w-full max-w-md rounded-lg my-2 overflow-hidden message-image relative">
                                    <div class="flex px-2 flex-col">
                                        <div class="flex gap-2">
                                            <b
                                            :class=" message.from == 'admin' ? 'order-2': 'order-1'"
                                             class="flex items-center justify-center w-8 h-8 rounded-full bg-gray-500 text-lg uppercase text-white"
                                             >{{ message.from == 'admin' ? message.admin.substring(0,1) || 'Support'.substring(0,1) : user && user.name.substring(0,1) }}</b>
                                            <img :src="message.content" :class=" message.from == 'admin' ? 'order-1 text-white bg-green-600': 'order-2 bg-white'" class="w-full px-1 rounded-lg pt-1" />
                                        </div>
                                        <span class="flex gap-2 items-center" :class=" message.from == 'admin' ? 'px-2': 'px-8'">
                                            <span v-if="message.seen && message.from == 'admin'" class="w-4 h-4">
                                                <svg class="w-4 h-4" :class="message.from == 'admin'?' text-green-500':' text-green-500'"  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                              <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                            </svg> </span>
                                                <span class="text-xs">{{ $moment(Number(message.key)).format('hh:mm A') }}</span>
                                                <button class="flex justify-center items-center cursor-pointer rounded-lg p-1 border-0 bg-transparent text-opacity-50 hover:text-danger hover:text-opacity-100" @click="deleteMessage(message)">
                                                    x
                                                </button>
                                            </span>
                                    </div>
                                </div>
                                <div style="max-width:90%" v-else-if="message.type == 'audio'" class="w-full max-w-md rounded-lg my-2 overflow-hidden message-audio relative">
                                    <div class="flex px-2 flex-col">
                                        <div class="flex gap-2">
                                            <b
                                            :class=" message.from == 'admin' ? 'order-2': 'order-1'"
                                             class="flex items-center justify-center w-8 h-8 rounded-full bg-gray-500 text-lg uppercase text-white"
                                             >{{ message.from == 'admin' ? message.admin.substring(0,1) || 'Support'.substring(0,1) : user && user.name.substring(0,1) }}</b>
                                            <audio controls class="w-full px-1 rounded-lg pt-1" :class=" message.from == 'admin' ? 'order-1 text-white': 'order-2 '" :src="message.content"></audio>
                                        </div>
                                        <span class="flex gap-2 items-center" :class=" message.from == 'admin' ? 'px-2': 'px-8'">
                                            <span v-if="message.seen && message.from == 'admin'" class="w-4 h-4">
                                                <svg class="w-4 h-4" :class="message.from == 'admin'?' text-green-500':' text-green-500'"  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                              <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                            </svg> </span>
                                                <span class="text-xs">{{ $moment(Number(message.key)).format('hh:mm A') }}</span>
                                                <button class="flex justify-center items-center cursor-pointer rounded-lg p-1 border-0 bg-transparent text-opacity-50 hover:text-danger hover:text-opacity-100" @click="deleteMessage(message)">
                                                    x
                                                </button>
                                            </span>
                                    </div>
                                        <svg class="w-4 h-4" :class="message.from == 'admin'?' text-white':' text-success'"  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                          <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                        </svg>                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
          <div
            v-if="sending"
            class="flex relative bg-white items-center justify-center p-2"
          >
            <span>Sending...</span>
          </div>
          <div v-else class="flex relative p-2 bg-transparent">
            <!-- message input -->
            <div
              v-if="image || audio || mediaRecorder"
              class="flex justify-between items-center absolute bg-white p-1 w-full bottom-0 z-10"
            >
              <!-- image base64 -->
              <div
                class="w-32 h-32 absolute bottom-0 m-1 shadow p-2 bg-white rounded-lg"
                style="left: 0"
                v-if="image"
              >
                <img
                  class="w-full h-full object-cover rounded-lg"
                  :src="image"
                />
              </div>
              <span v-if="image"></span>
              <!-- audio base64 -->
              <div
                v-if="mediaRecorder"
                class="bg-black rounded-lg p-1 w-full relative flex justify-center items-center bg-contain"
                :style="
                  recordingState == 'recording'
                    ? `background-image:url('https://storeno.b-cdn.net/managers/5-2022/1652470773713.gif')`
                    : ''
                "
              >
                <!-- Recording audio -->
                <small
                  class="text-xs text-white bottom-0 p-1 absolute capitalize"
                  style="left: 0"
                  >{{ recordingState }}</small
                >
                <button
                  class="bg-white text-danger w-16 h-10 text-xs flex justify-center items-center rounded-full border-2 cursor-pointer border-white border-solid"
                  v-if="recordingState == 'recording'"
                  @click="mediaRecorder.stop()"
                >
                  <span>{{ "Stop" }}</span>
                </button>
                <small
                  class="text-xs text-white bottom-0 p-1 absolute"
                  style="right: 0"
                  >{{ recordingTime }}</small
                >
              </div>
              <!-- audio base64 -->
              <div v-if="audio" class="flex w-full items-center p-1">
                <audio
                  controls
                  class="w-full h-10"
                  preload="auto"
                  id="audioRecord"
                >
                  <source :src="audio" type="audio/mpeg" />
                </audio>
              </div>
              <div class="flex justify-center p-1">
                <button
                  v-if="audio"
                  @click="audio = null"
                  class="flex items-center justify-center bg-red-500 text-white rounded border-0 cursor-pointer h-10 w-10"
                >
                  x
                </button>
                <button
                  v-if="image"
                  @click="image = null"
                  class="flex items-center justify-center bg-red-500 text-white rounded border-0 cursor-pointer h-10 w-10"
                >
                  x
                </button>
                <span class="mr-1"></span>
                <div
                  @click="sendMessage"
                  class="flex-none"
                  v-if="!mediaRecorder"
                >
                  <button
                    class="flex items-center justify-center bg-blue-500 text-white rounded border-0 cursor-pointer h-10 w-10"
                  >
                     <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
                    />
                  </svg>
                  </button>
                </div>
              </div>
            </div>
            <form
              @submit.prevent="sendMessage"
              class="flex w-full p-2 bg-white p-1 items-center"
            >
              <span class="mr-1"></span>
              <!-- message -->
              <div class="flex-1">
                <input
                  id="messageInput"
                  v-model="message.content"
                  class="w-full border-0 p-2 h-full rounded"
                  placeholder="Type your message here"
                />
              </div>
              <span class="mr-1"></span>
              <!-- image -->
              <div class="flex-none">
                <button
                  type="button"
                  @click="setImage"
                  class="flex items-center justify-center text-gray-600 rounded-full border-0 cursor-pointer hover:bg-gray-400 h-10 w-10"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13"
                    />
                  </svg>
                </button>
              </div>
              <!-- Audio -->
              <div class="flex-none">
                <button
                  type="button"
                  @click="startAudio"
                  class="flex items-center justify-center text-gray-600 rounded-full border-0 cursor-pointer hover:bg-gray-400 h-10 w-10"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M12 18.75a6 6 0 0 0 6-6v-1.5m-6 7.5a6 6 0 0 1-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 0 1-3-3V4.5a3 3 0 1 1 6 0v8.25a3 3 0 0 1-3 3Z"
                    />
                  </svg>
                </button>
              </div>
              <span class="mr-1"></span>
              <!-- Send button -->
              <div class="flex-none">
                <button
                  class="flex items-center justify-center bg-blue-500 text-white rounded-md border-0 cursor-pointer bg-primary h-10 w-10"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
                    />
                  </svg>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showUsers: true,
      limit:50,
      query: '',
      sending: false,
      firebase: null,
      users: [],
      messages: [],
      message: {
        content: "",
        type: "text",
        seen: false,
        from: "admin",
        subdomains: "",
      },
      image: null,
      audio: null,
      user: null,
      refs: { users: null, messages: null },
      mediaRecorder: null,
      recordingState: "",
      recordingTime: "00:00",
      showDetails: false,
      notify: new Audio(require("@/assets/ringtone/noti.wav")),
    };
  },
  async mounted() {
    console.log("Start Mounted");
    // if (this.$store.getters.getInit.user.position === "ADMIN") {
      await this.initFirebase();
      if (!this.firebase) return alert("Firebase not initialized");
      this.getFromFirebase();
      console.log("End Mounted");
    // }
    // onresize
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    clear(){
        this.query = ''
        this.getFromFirebase();
    },
    onResize() {
      if (window.innerWidth < 768) {
        this.showUsers = false;
      } else {
        this.showUsers = true;
      }
    },
    async initFirebase() {
      return new Promise((resolve, reject) => {
        let firebasecdn = document.createElement("script");
        let databasecdn = document.createElement("script");
        let fbauthcdn = document.createElement("script");
        let cryptoAES = document.createElement("script");
        firebasecdn.src =
          "https://www.gstatic.com/firebasejs/7.17.1/firebase-app.js";
        databasecdn.src =
          "https://www.gstatic.com/firebasejs/7.17.1/firebase-database.js";
        fbauthcdn.src =
          "https://www.gstatic.com/firebasejs/7.17.1/firebase-auth.js";
        cryptoAES.src =
          "https://cdnjs.cloudflare.com/ajax/libs/crypto-js/3.1.2/rollups/aes.js";
        document.head.appendChild(firebasecdn);
        firebasecdn.onload = () => {
          console.log("Firebase Loaded");
          document.head.appendChild(databasecdn);
          databasecdn.onload = () => {
            console.log("Database Loaded");
            document.head.appendChild(fbauthcdn);
            fbauthcdn.onload = () => {
              console.log("Auth Loaded");
              document.head.appendChild(cryptoAES);
              cryptoAES.onload = async () => {
                console.log("Crypto Loaded");
                let secret = null;
                let decryptedPack = {};
                let fbdecryptedPack = {};
                secret =
                  "LTNbckMnVTBjUD1BXVZXLn4sWHh+YUA=TVs0bWwzL18rMSw7ZUJgXGtVQmtFTA==a2Z4KypyNWcrPixeMHlNLyhjczdrMH5lfDIpRA==e0EhdU4pUUxeRlUsTCVzUVorZg==";
                let cryptedPack = {
                  email:
                    "U2FsdGVkX1/c5TVVPpaXiL7bwEMcEvJQFvyYZAVzMvn1c0kldODjuDBpVG+0FrzO",
                  password:
                    "U2FsdGVkX19Gl3dJrn0XrJr9HcvTLQaLC1Qv9aEyZlSuzYrS4ucxtZxl8C7b1x42swtz1PmuV8iO2VLtaEbm6g==",
                };
                let fbcryptedPack = {
                  apiKey: "AIzaSyD1MPTM3jpsmiAdnbuUU3sBNhOLAGRWNZw",
                  authDomain: "eshipi-chatlive.firebaseapp.com",
                  projectId: "eshipi-chatlive",
                  storageBucket: "eshipi-chatlive.appspot.com",
                  messagingSenderId: "734427857229",
                  appId: "1:734427857229:web:860f818cc4244b72d1f704",
                  databaseURL:"https://eshipi-chatlive-default-rtdb.firebaseio.com"
                };
                // decryptedPack.email = CryptoJS.AES.decrypt(
                //   cryptedPack.email,
                //   secret
                // ).toString(CryptoJS.enc.Utf8);
                // decryptedPack.password = CryptoJS.AES.decrypt(
                //   cryptedPack.password,
                //   secret
                // ).toString(CryptoJS.enc.Utf8);
                // fbdecryptedPack.apiKey = CryptoJS.AES.decrypt(
                //   fbcryptedPack.apiKey,
                //   secret
                // ).toString(CryptoJS.enc.Utf8);
                // fbdecryptedPack.authDomain = CryptoJS.AES.decrypt(
                //   fbcryptedPack.authDomain,
                //   secret
                // ).toString(CryptoJS.enc.Utf8);
                // fbdecryptedPack.databaseURL = CryptoJS.AES.decrypt(
                //   fbcryptedPack.databaseURL,
                //   secret
                // ).toString(CryptoJS.enc.Utf8);
                // fbdecryptedPack.projectId = CryptoJS.AES.decrypt(
                //   fbcryptedPack.projectId,
                //   secret
                // ).toString(CryptoJS.enc.Utf8);
                // fbdecryptedPack.storageBucket = CryptoJS.AES.decrypt(
                //   fbcryptedPack.storageBucket,
                //   secret
                // ).toString(CryptoJS.enc.Utf8);
                // fbdecryptedPack.messagingSenderId = CryptoJS.AES.decrypt(
                //   fbcryptedPack.messagingSenderId,
                //   secret
                // ).toString(CryptoJS.enc.Utf8);
                // fbdecryptedPack.appId = CryptoJS.AES.decrypt(
                //   fbcryptedPack.appId,
                //   secret
                // ).toString(CryptoJS.enc.Utf8);
                if (firebase.apps && firebase.apps.length == 0)
                  await firebase.initializeApp(fbcryptedPack);
                console.log("Firebase Initialized");
                this.firebase = firebase;
                // firebase.auth().signInWithEmailAndPassword(decryptedPack.email,decryptedPack.password).then((userCredential) => {
                //     console.log("Logged In 1");
                // }).catch((error) => console.log(error));
                // firebase.auth().onAuthStateChanged((user) => { if (user) {
                //     console.log("Logged In 2");
                //     resolve(user.uid);
                // } else {
                //     console.log("Error Logged In 3");
                // } });
                    resolve("Firebase Initialized");
              };
            };
          };
        };
      });
    },
    async startAudio() {
      console.log("Start Audio");
      // start audio recording audio stream using getUserMedia
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      this.$set(this, "mediaRecorder", new MediaRecorder(stream));
      console.log(this.mediaRecorder);
      const audioChunks = [];
      this.mediaRecorder.addEventListener("dataavailable", (event) => {
        audioChunks.push(event.data);
      });
      this.$set(this, "recordingState", this.mediaRecorder.state);
      this.mediaRecorder.addEventListener("stop", () => {
        if (window.recordingInterval) clearInterval(window.recordingInterval);
        const blob = new Blob(audioChunks, { type: "audio/mp3" });
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          this.recordingState = null;
          this.mediaRecorder = null;
          this.audio = reader.result;
          this.$nextTick(() => {
            const audioEl = document.querySelector("#audioRecord");
            audioEl.play();
            this.$nextTick(() => {
              audioEl.pause();
              audioEl.currentTime = 0;
            });
          });
        };
      });
      this.mediaRecorder.addEventListener("start", () => {
        console.log("Started");
        this.$set(this, "recordingState", "recording");
        window.startRecordingTime = Date.now();
        window.recordingInterval = setInterval(() => {
          let minues = Math.floor(
            (Date.now() - window.startRecordingTime) / 60000
          );
          let seconds = Math.floor(
            ((Date.now() - window.startRecordingTime) % 60000) / 1000
          );
          if (minues < 10) minues = "0" + minues;
          if (seconds < 10) seconds = "0" + seconds;
          this.recordingTime = `${minues}:${seconds}`;
        }, 500);
      });
      this.mediaRecorder.start();
    },
    async setImage() {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";
      input.onchange = (e) => {
        // base 64
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onload = (e) => {
          this.image = e.target.result;
        };
        reader.readAsDataURL(file);
      };
      input.click();
    },
    async openConversation(key,userData) {
      // Check if mobile using window size
      this.firebase.database().ref('users/'+key).once('value').then((snapshot) => {
            const content = snapshot.val();
            console.log({content});
            this.user = { key: snapshot.key, ...content }; // what that
            console.log('key____',key);
            console.log('user____',this.user);
            if(!content){
                this.firebase.database().ref('users/'+key).set({
                    lastActivity:1652449801371,
                    lastFrom:"user",
                    typeUser:userData.type,
                    lastMessage:"No Message",
                    fullName: userData.fullName,
                    email: userData.email,
                });
                this.user = { key, ...{
                    lastActivity:1652449801371,
                    lastFrom:"user",
                    typeUser:userData.type,
                    lastMessage:"No Message",
                    fullName: userData.fullName,
                    email: userData.email,
                } }
            } else {
                console.log("User Created");
            }
        });
      if (window.innerWidth < 768) {
        this.showUsers = false;
      }
    //   this.user = this.users.find((user) => user.key == key); // ??
      console.log('state___',this.$store.state);
      // unread to 0
      this.firebase.database().ref(`/users/${key}/unread`).set(0);

      this.messages = [];
      if (this.refs.messages) {
        this.refs.messages.off("child_added");
        this.refs.messages.off("child_changed");
        this.refs.messages.off("child_removed");
      }
      this.refs.messages = this.firebase
        .database()
        .ref("conversations/" + key)
        .orderByKey();
      this.refs.messages.on("child_added", (snapshot) => {
        const data = snapshot.val();
        if (data.type == "text")
          data.content = data.content
            .replace(/(<([^>]+)>)/gi, "")
            .replace(/&nbsp;/g, " ");
        // convert links
        if (data.type == "text") data.content = this.convertLinks(data.content);
        this.$nextTick(() => {
          document.getElementById("scroll-box").scrollTop =
            document.getElementById("scroll-box").scrollHeight;
        });
        if (data.from == "user" && data.seen == false) {
          this.firebase
            .database()
            .ref("conversations/" + key + "/" + snapshot.key)
            .update({ seen: true });
          data.seen = true;
        }
        this.messages.push({ key: snapshot.key, ...data });
        // sort by key
        this.messages.sort((a, b) => {
          if (a.key < b.key) return -1;
          if (a.key > b.key) return 1;
          return 0;
        });
      });
      this.refs.messages.on("child_changed", (snapshot) => {
        const index = this.messages.findIndex(
          (message) => message.key == snapshot.key
        );
        if (index != -1) {
          this.$set(this.messages, index, {
            key: snapshot.key,
            ...snapshot.val(),
          });
          this.$nextTick(() => {
            document.getElementById("scroll-box").scrollTop =
              document.getElementById("scroll-box").scrollHeight;
          });
        }
      });
      this.refs.messages.on("child_removed", (snapshot) => {
        const index = this.messages.findIndex(
          (message) => message.key == snapshot.key
        );
        if (index != -1) {
          this.messages.splice(index, 1);
        }
      });
      try {
        // const response = await this.$http.get(
        //   `${this.$store.state.api_managers}/api/stores/search`,
        //   {
        //     params: { users: key, limit: 4 },
        //   }
        // );
        // this.$set(this.user, "stores", response.data.results);
      } catch (error) {
        console.log("err", error);
      }
    },
    async deleteMessage(message) {
      if (!this.user.key) return;
      // Backup
      this.firebase
        .database()
        .ref("archive/" + this.user.key)
        .child(message.key)
        .set(message);
      this.firebase
        .database()
        .ref("conversations/" + this.user.key + "/" + message.key)
        .remove();
    },
    async sendMessage() {
      // add message to conversation / user
      this.sending = true;
      let content = this.message.content.trim();
      let type = this.message.type;
      if (this.image) {
        try {
        const data = await this.$server.create("medias",{ src: this.image } );
          content = data.content;
          type = "image";
        } catch (error) {
          console.log("err", error);
        }
      }
      if (this.audio) {
        try {
          const data = await this.$server.create("medias",   { src: this.audio } );
          content = data.content;
          type = "audio";
        } catch (error) {
          console.log("err", error);
        }
      }
      if (!content) {
        this.sending = false;
        return;
      }
      // Audio
      if (["mp3", "wav", "ogg"].includes(content.split(".").pop())) {
        type = "audio";
      }
      // Image
      if (
        ["jpg", "jpeg", "png", "gif", "webp"].includes(content.split(".").pop())
      ) {
        type = "image";
      }
      this.firebase
        .database()
        .ref("conversations/" + this.user.key)
        .child(new Date().getTime())
        .set({
          content: content,
          type: type,
          seen: false,
          from: "admin",
          admin:this.$store.state.user.fullName,
        })
        .then(() => {
          this.message.content = "";
          this.image = null;
          this.audio = null;
          // update user last activity
          this.firebase
            .database()
            .ref("users/" + this.user.key)
            .update({
              lastActivity: new Date().getTime(),
              lastMessage: type == "text" ? content : `[${type.toUpperCase()}]`,
              lastFrom: "admin",
            });
          this.sending = false;
          this.$nextTick(() => {
            if (document.querySelector("#messageInput"))
              document.querySelector("#messageInput").focus();
            else console.log("No input");
          });
        })
        .catch(() => {
          this.sending = false;
          this.$nextTick(() => {
            if (document.querySelector("#messageInput"))
              document.querySelector("#messageInput").focus();
            else console.log("No input");
          });
        });
    },
    convertLinks(input) {
      let text = input;
      const linksFound = text.match(/(?:www|https?)[^\s]+/g);
      const aLink = [];

      if (linksFound != null) {
        for (let i = 0; i < linksFound.length; i++) {
          let replace = linksFound[i];
          if (!linksFound[i].match(/(http(s?)):\/\//)) {
            replace = "http://" + linksFound[i];
          }
          let linkText = replace.split("/")[2];
          if (linkText.substring(0, 3) == "www") {
            linkText = linkText.replace("www.", "");
          }
          if (linkText.match(/youtu/)) {
            let youtubeID = replace.split("/").slice(-1)[0];
            if (youtubeID.indexOf("=") > -1)
              youtubeID = youtubeID.split("=")[1];
            aLink.push(
              '<div style="padding-bottom: 57%;width: 100%;position: relative;min-width: 260px;"><iframe style="position: absolute;width: 100%;height: 100%;" src="https://www.youtube.com/embed/' +
                youtubeID +
                '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>'
            );
          } else if (linkText.match(/vimeo/)) {
            let vimeoID = replace.split("/").slice(-1)[0];
            aLink.push(
              '<div class="video-wrapper"><iframe src="https://player.vimeo.com/video/' +
                vimeoID +
                '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>'
            );
          } else {
            aLink.push(
              '<a href="' + replace + '" target="_blank">' + linkText + "</a>"
            );
          }
          text = text
            .split(linksFound[i])
            .map((item) => {
              return aLink[i].includes("iframe") ? item.trim() : item;
            })
            .join(aLink[i]);
        }
        return text;
      } else {
        return input;
      }
    },
    async getUsers(paginate = false) {
      this.loading = true;
      if (!paginate) this.users = [];
      let key = "";
      let filter = {
                limit:{limit:10},
                };
      if (this.query) {
        if (this.query.indexOf("@") != -1) {
             filter = {
                limit:{limit:10},
                email: this.query,
                };
         
        }else{
            filter = {
                limit:{limit:10},
                name: this.query,
                };
        }
        const response = await this.$server.find("users",filter);
          if (response.content.results.length > 0) {
            this.users = response.content.results
          }
      }
      // Search by user key
      console.log('key',key);
      this.loading = false
    },
    getFromFirebase(key = null){
        console.log({key});
        this.users =[]
        if (key) {
        this.refs.users = this.firebase
          .database()
          .ref("users")
          .orderByKey()
          .startAt(key)
          .endAt(key + "\uf8ff");
      } else {
        console.log('this.users',this.users);
          this.refs.users = this.firebase
            .database()
            .ref("users")
            .orderByChild("lastActivity")
            .limitToLast(this.limit);
    
      }
      console.log('dataa',this.refs.users);
      this.loading = false;
      this.refs.users.on("child_added", (result) => {
          console.log('dataa',result.val());
          const data = result.val();
        if (!data.lastMessage) data.lastMessage = "";
        if (this.users.findIndex((user) => user._id == result.key) == -1) {
          this.users.push({ _id: result.key, ...data });
        }
        this.users.sort((a, b) => {
          return b.lastActivity - a.lastActivity;
        });
        console.log('this.users',this.users);
        if (
          Number(data.lastActivity) > new Date().getTime() - 5000 &&
          data.lastFrom == "user"
        ) {
          console.log("New Message from user");
          this.notify.play();
        }
      });
      this.refs.users.on("child_changed", (result) => {
        const index = this.users.findIndex((user) => user._id == result.key);
        const data = result.val();
        if (index > -1) {
          if (!data.lastMessage) data.lastMessage = "";
          this.users[index] = { _id: result.key, ...data };
        } else {
          if (!data.lastMessage) data.lastMessage = "";
          this.users.push({ _id: result.key, ...data });
        }
        this.users.sort((a, b) => {
          return b.lastActivity - a.lastActivity;
        });
        console.log('this.users2',this.users);
        console.log('this.refs.users',this.refs.users);
        if (
          Number(data.lastActivity) > new Date().getTime() - 5000 &&
          data.lastFrom == "user"
        ) {
          console.log("New Message from user");
          this.notify.play();
        }
      });
    }
  },
};
</script>
<style>
.v-nav-menu-swipe-area {
  display: none !important;
}
</style>
<style scoped>
.livechat {
  font-family: "Cairo", Helvetica, Arial, sans-serif !important;
}
.livechat * {
  font-family: "Cairo", Helvetica, Arial, sans-serif !important;
}
audio#audioRecord::-webkit-media-controls-current-time-display,
audio#audioRecord::-webkit-media-controls-time-remaining-display {
  display: none;
}
.message-from-user {
  justify-content: flex-start;
}
.message-from-admin {
  justify-content: flex-end;
}
.message-from-user a,
.message-from-admin a {
  color: #fff !important;
  text-decoration: underline !important;
}
.message-from-user > div.message-audio,
.message-from-admin > div.message-audio {
  max-width: 360px !important;
}
.message-from-user > div audio::-webkit-media-controls-play-button,
.message-from-user > div audio::-webkit-media-controls-panel {
  background-color: #c5e1ad;
}
.message-from-admin > div audio {
  filter: invert(1);
}
.message-from-admin > div audio::-webkit-media-controls-play-button,
.message-from-admin > div audio::-webkit-media-controls-panel {
  background-color: #d16c4a;
}
</style>
